// import { getRunBrowser } from '@/utils/runTimeEnv'
import sensors from './sensors'

/**
 * 神策埋点
 * 页面停留时长
 * pageEventName 页面事件名称
 * enterTime 进入页面时间：13位时间戳
 * 页面地址
 */

const  PCautoActivityGetPriceResult = (
  pcauto_activity_id: number,
  pcauto_activity_name: string,
  pcauto_series_id: string,
  pcauto_is_success: boolean,
  pcauto_fail_reason: string,
) => {
    // if (getRunBrowser() == 1) {
      sensors.track('PCautoActivityGetPriceResult', {
        pcauto_activity_id,
        pcauto_activity_name,
        pcauto_series_id,
        pcauto_is_success,
        pcauto_fail_reason,
      })
    // } 
    
}

export default {
  PCautoActivityGetPriceResult
}
